import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PaginationProps {
  page: number
  totalPages: number
  total: number
  limit: number
  onPageChange: (page: number) => void
  className?: string
  /** Shown when total === 0. Defaults to "No members" for existing callers. */
  emptyLabel?: string
}

export function Pagination({
  page,
  totalPages,
  total,
  limit,
  onPageChange,
  className,
  emptyLabel = 'No members',
}: PaginationProps) {
  const from = total === 0 ? 0 : (page - 1) * limit + 1
  const to = Math.min(page * limit, total)

  return (
    <div
      className={cn(
        'flex flex-col gap-3 border-t border-border-2 px-6 py-4 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <p className="font-sans text-sm text-muted-foreground">
        {total === 0 ? emptyLabel : `Showing ${from}–${to} of ${total}`}
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <ChevronLeft size={16} />
          Previous
        </Button>
        <span className="px-2 font-sans text-sm text-muted-foreground">
          Page {page} of {totalPages}
        </span>
        <Button
          variant="secondary"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          Next
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  )
}
